import { jsx as _jsx } from "react/jsx-runtime";
import { Button, MaximizeIcon, MinimizeIcon } from '@streamr/tv-ui';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
export function FullscreenButton({ element, onFullscreenChange, }) {
    const canRequestFullscreen = useMemo(() => !!element && canRequestFullscreenOnElement(element), [element]);
    const isFullscreen = useIsFullscreen();
    useEffect(() => {
        onFullscreenChange?.(isFullscreen);
    }, [isFullscreen, onFullscreenChange]);
    if (!canRequestFullscreen) {
        return null;
    }
    return (_jsx(FullscreenButtonRoot, { type: "button", kind: ['pill', 'secondary'], onClick: () => {
            if (isFullscreen) {
                // biome-ignore lint/nursery/noFloatingPromises: TODO
                exitFullscreen();
            }
            else {
                if (element) {
                    // biome-ignore lint/nursery/noFloatingPromises: TODO
                    requestFullscreen(element);
                }
            }
        }, children: isFullscreen ? _jsx(MinimizeIcon, {}) : _jsx(MaximizeIcon, {}) }));
}
function canRequestFullscreenOnElement(element) {
    return !!(element.requestFullscreen || element.webkitRequestFullscreen);
}
function useIsFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(() => !!getFullscreenElement());
    useEffect(function handleFullscreenEvents() {
        const onFullscreenChange = () => {
            setIsFullscreen(!!getFullscreenElement());
        };
        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
        };
    }, []);
    return isFullscreen;
}
function getFullscreenElement() {
    const element = typeof document !== 'undefined'
        ? document.fullscreenElement || document.webkitFullscreenElement
        : null;
    return element || undefined;
}
function requestFullscreen(element, options) {
    const fn = element.requestFullscreen ||
        element.webkitRequestFullscreen ||
        (() => Promise.reject(new Error('Not supported')));
    return fn.bind(element)(options);
}
async function exitFullscreen() {
    const fn = document.exitFullscreen ||
        document.webkitExitFullscreen ||
        (() => Promise.reject(new Error('Not supported')));
    await fn.bind(document)();
}
const FullscreenButtonRoot = styled(Button) `
    --Button_Width: 2.75rem;
    --Button_Height: 2.75rem;
    backdrop-filter: blur(10px);

    svg {
        transform: scale(0.75);
    }
`;
